const RETURN_PATH_KEY = "auth_return_path";

/**
 * Utility for managing redirection after authentication
 */
export const AuthRedirection = {
  /**
   * Save the current path as the return path for after authentication
   */
  setReturnPath(path: string = window.location.pathname + window.location.search): void {
    // Only save if it's not an auth route itself
    if (path.includes("/auth/")) return;

    localStorage.setItem(RETURN_PATH_KEY, path);
    console.log(`[AuthRedirection] Saved return path: ${path}`);
  },

  /**
   * Get the saved return path and clear it
   */
  getAndClearReturnPath(): string | null {
    const path = localStorage.getItem(RETURN_PATH_KEY);
    localStorage.removeItem(RETURN_PATH_KEY);

    if (path) {
      console.log(`[AuthRedirection] Retrieved return path: ${path}`);
    }

    return path;
  },

  /**
   * Get the best available return path
   */
  resolveReturnPath(defaultPath: string = "/dashboard"): string {
    const saved = this.getAndClearReturnPath();
    if (saved) return saved;

    return defaultPath;
  },
};
